import { makeStyles } from "@mui/styles";
import color from "@definitions/mui/color";

interface IUseStyles {
  tabs: boolean;
  isSelected: boolean;
  staticHeight: boolean;
  positionGap: any;
}

const useStyles = ({ tabs, isSelected, staticHeight, positionGap }: IUseStyles) => {
  let tabsGap = 57;
  if (tabs) {
    if (positionGap) {
      tabsGap = positionGap;
    } else {
      tabsGap = 144;
    }
  }

  return makeStyles(() => ({
    headerWrapper: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      padding: "16px 16px 0px 16px",
      zIndex: 10,
      backgroundColor: color.white,
    },
    header: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: 16,
    },
    clickableIcon: {
      marginRight: 20,
      color: color.general.main,
      display: "flex",
      alignItems: "center",
    },
    tools: {
      marginTop: tabsGap,
      display: "flex",
      gap: 12,
      width: "100%",
      position: "relative",
      height: isSelected && !staticHeight ? 85 : "auto",
    },
    icon: {
      color: color.general.main,
      display: "flex",
      alignItems: "center",
      height: 20,
      width: 20,
    },
  }))();
};

export default useStyles;
